export const ROUTES = {
  USER_INSIGHTS_DASHBOARD: "viewUserInsightsDashboard"
};
